import Head from 'next/head';

export const HotjarHead = () => {
  const isProduction = process.env.GONDOLA_ENV === 'production';

  if (!isProduction) return null;

  return (
    <Head>
      <link rel="preconnect" href="https://script.hotjar.com" crossOrigin="anonymous" />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                (function(h,o,t,j,a,r){
                h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
                h._hjSettings={hjid:3368304,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `,
        }}
      />
    </Head>
  );
};
